import React, { useContext } from "react";
import "../styles/basketItemDiscount.css";
import { LanguageContext } from "../context/language/LanguageContext";
import appConst from "../Utilities/appConst.json";
import { useSelector } from "react-redux";
import { calendarFormatDescriptionMap } from "../Utilities/mapUtil";

export default function SummaryItemCalendarDefaultDetails(props) {
  const languageContext = useContext(LanguageContext);
  const formatsArray = useSelector((state) => state.user.calendarFormats);
  const formatDescription =
    calendarFormatDescriptionMap.get(props.item.format) || null;
  const formatLable = formatDescription || formatsArray?.find(
    (x) => x.value == props.item.format
  )?.label;

  return (
    <div className="position_flex_rtl">
      {formatLable || languageContext.getTranslation(appConst.FORMAT)}
    </div>
  );
}
